import { sectionRenderer } from '@theme/section-renderer';

class ProductAPIData {
  constructor() {
    this.cartItemsId = document.querySelector('cart-items-component').dataset.sectionId;
    this.apiUrl = document.querySelector('.voo-main-product[data-api]').dataset.api;
    this.mediaGallery = document.querySelector('.voo-main-product__media media-gallery-infinite');
    this.variantImageId = this.mediaGallery.querySelector('.voo-dynamic-image:not(.is-clone)')?.dataset.mediaId;
    this.dynamicImages = document.querySelectorAll('li.voo-dynamic-image');
    this.variants = document.querySelectorAll('.section-variants .variant-values');
    this.imageBaseSrc = 'https://primeeva.com/cdn/shop/files/';
    this.productTypes = {
      universal_mat: { url_param: 'floor_mats_', product_type: 'floor_mats' },
      storage: { url_param: 'organizer_', product_type: 'organizer' },
      knee_pad: { url_param: 'knee_pads_', product_type: 'knee_pads' },
    };
    this.cartDrawer = document.querySelector('cart-drawer-component');
  }

  setLocalStorageOptions() {
    if (this.variants.length == 0) return;

    this.variants.forEach((variant) => {
      variant.querySelectorAll('input').forEach((input) => {
        if (input.checked == 1) {
          localStorage.setItem(variant.dataset.option, input.dataset.color);
        }
      });
    });
  }

  async updateOptionColors() {
    let responce = await fetch(this.apiUrl + 'option_colors', {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        locale: document.querySelector('html').getAttribute('lang'),
        product_type: this.currentProduct.product_type,
      }),
    }).catch((error) => {
      console.error(error);
    });

    if (responce.status == 200) {
      const json = await responce.json();
      if (json.data.length == 0 && document.querySelector('.variant-values input[data-code]')) {
        this.variants.forEach((variant) => {
          variant.querySelectorAll('input').forEach((input, i) => {
            input.setAttribute('data-color', input.dataset.code);
          });
        });
      } else {
        this.variants.forEach((variant) => {
          let optionsArray = json.data.filter((dataItem) => {
            if (variant.dataset.option.toLowerCase().replace(' ', '_') == dataItem.type) {
              return dataItem.label;
            }
          });
          variant.querySelectorAll('input').forEach((input) => {
            optionsArray.forEach((option) => {
              if (input.value == option.label) {
                input.setAttribute('data-color', option.code);
              }
            });
          });
        });
      }
    }
  }

  async updateImageSrc(image, index) {
    let textureColor = '';
    let borderColor = '';
    let matColor = '';
    let color;
    if (this.variants.length < 2) {
      color = this.variants[0].querySelector('input:checked').dataset.color;
    } else {
      textureColor = this.variants[0].querySelector('input:checked').dataset.color;
      borderColor = this.variants[1].querySelector('input:checked').dataset.color;
      matColor = this.variants[2].querySelector('input:checked').dataset.color;
    }
    let additionalUrlParametr = '';
    if (this.currentProduct) {
      additionalUrlParametr = this.currentProduct.url_param;
    }
    const imageSrc = `${this.imageBaseSrc}${additionalUrlParametr}${index}_${textureColor}_${matColor}_${borderColor == '' ? color : borderColor}.jpg?width=${image.getAttribute('width')}`;
    if (textureColor || borderColor || matColor || color) {
      this.imageExists(imageSrc).then((res) => {
        if (res.status == 200) {
          document.querySelectorAll('product-modal .product-media-modal__content img').forEach((zoomImage) => {
            if (image.src.split('?')[0] == zoomImage.src.split('?')[0]) {
              let zoomImageSrc = `${this.imageBaseSrc}${additionalUrlParametr}${index}_${textureColor}_${matColor}_${borderColor == '' ? color : borderColor}.jpg`;
              zoomImage.src = zoomImageSrc + '?' + zoomImage.src.split('?')[1];
              zoomImage.srcset = zoomImageSrc + '?' + 'width=550 550w,' + zoomImageSrc + ' 1000w';
            }
          });

          // Update for thumbnail
          document.querySelectorAll('.voo-thumbnail .thumbnail-slider img').forEach((thumbImage) => {
            if (image.src.split('?')[0] == thumbImage.src.split('?')[0]) {
              let thumbImageSrc = `${this.imageBaseSrc}${additionalUrlParametr}${index}_${textureColor}_${matColor}_${borderColor == '' ? color : borderColor}.jpg`;
              thumbImage.src = thumbImageSrc + '?' + thumbImage.src.split('?')[1];
              thumbImage.srcset = thumbImageSrc + '?' + 'width=550 550w,' + thumbImageSrc + ' 1000w';
            }
          });

          image.src = imageSrc;
        }
      });
    } else {
      console.error('Some of picture params not exist');
    }
  }

  async imageExists(imageUrl) {
    return fetch(`${imageUrl}`).then((res) => res);
  }

  getOptionTypeMapping() {
    return {
      texture: {
        keywords: ['textur', 'tekstura', 'pattern'],
        priority: 1,
      },
      border_color: {
        keywords: ['einfassung', 'border_color'],
        compound: [{ terms: ['border', 'color'] }, { terms: ['kolor', 'obszycia'] }],
        priority: 2,
      },
      mat_color: {
        keywords: ['mat_color'],
        compound: [{ terms: ['mat', 'color'] }, { terms: ['matte', 'farbe'] }, { terms: ['kolor', 'dywanika'] }],
        singleOptionKeywords: ['farbe', 'color', 'kolor'],
        priority: 3,
      },
    };
  }

  normalizeOptionName(optionName) {
    if (!optionName) return '';
    return optionName.toLowerCase().replace(/\s+/g, '_');
  }

  matchesCompoundTerms(normalized, compoundTerms) {
    return compoundTerms.every((term) => normalized.includes(term));
  }

  determineOptionType(optionName, isSingleOption = false) {
    if (!optionName) return null;

    const normalized = this.normalizeOptionName(optionName);
    const mapping = this.getOptionTypeMapping();

    const sortedTypes = Object.entries(mapping).sort((a, b) => a[1].priority - b[1].priority);

    for (const [type, config] of sortedTypes) {
      if (config.keywords?.some((keyword) => normalized.includes(keyword))) {
        return type;
      }

      if (config.compound?.some((compound) => this.matchesCompoundTerms(normalized, compound.terms))) {
        return type;
      }

      if (
        isSingleOption &&
        config.singleOptionKeywords?.some((keyword) => normalized.includes(keyword) || normalized === keyword)
      ) {
        return type;
      }
    }

    return null;
  }

  setVariantProperties(properties) {
    const isSingleOption = this.variants.length === 1;

    this.variants.forEach((variant) => {
      const checkedInput = variant.querySelector('input:checked');
      if (!checkedInput?.dataset.color) return;

      const optionType = this.determineOptionType(variant.dataset.option, isSingleOption);
      if (optionType) {
        properties[`_${optionType}`] = checkedInput.dataset.color;
      }
    });
  }

  addToCart(redirectToCart = false) {
    let items = [];
    const variantsData = JSON.parse(document.querySelector('#variants_json[type="application/json"]').textContent);

    // Get variant barcode
    let barcode = '';
    variantsData.forEach((variant) => {
      if (variant.id === Number(document.getElementById('current-variant').value)) {
        barcode = variant.barcode;
      }
    });

    items.push({
      id: Number(document.getElementById('current-variant').value),
      quantity: 1,
      properties: {
        _locale: document.querySelector('html').getAttribute('lang'),
        _currenturl: window.location.href,
        _barcode: barcode,
        '_Order Status': 'Jetzt Bestellen -',
        _order_status: 'order',
      },
    });

    // Set options
    ['texture', 'mat_color', 'border_color'].forEach((option) => {
      if (document.querySelector(`input.${option}-value-input:checked`)) {
        items[0].properties[`_${option}`] = document.querySelector(`input.${option}-value-input:checked`).dataset.color;
      }
    });

    if (this.currentProduct.product_type !== 'knee_pads') {
      items[0].properties['_Knee pad'] = 'Knee pad';
    }

    let formData = {
      items: items,
      sections: this.getSectionsToRender().map((section) => section.id),
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((response) => {
        if (this.cartDrawer) {
          this.cartDrawer.querySelector('.cart-drawer__inner')?.classList.remove('cart-drawer--empty');
          this.cartDrawer.classList.remove('is-empty');
        }
        sectionRenderer.renderSection(this.cartItemsId, { cache: false });
        this.cartDrawer?.open();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  async init() {
    // Update product type
    for (const key in this.productTypes) {
      if (document.querySelector('.voo-main-product[data-template]').dataset.template == key) {
        document.querySelector('.voo-main-product[data-domain]').setAttribute('data-type', `${key}`);
        this.currentProduct = this.productTypes[key];
        if (key === 'storage') {
          this.currentProduct.url_param +=
            document.querySelector('.voo-main-product[data-template]').dataset.size + '_';
        }
      }
    }

    // Update data colors for variants
    await this.updateOptionColors();

    // Update images url to dynamic
    document.querySelectorAll('li.voo-dynamic-image').forEach((item) => {
      const image = item.querySelector('img');
      this.updateImageSrc(image, item.dataset.index);
    });

    // Remove Disable from add to cart
    document.querySelector('.add-to-cart').removeAttribute('disabled');
    document.querySelectorAll('.product-type-switcher').forEach((switcher) => {
      switcher.dataset.disabled = 'false';
    });

    // Event add to Cart
    document.querySelector('.add-to-cart').addEventListener('click', (e) => {
      e.preventDefault();
      if (!e.target.hasAttribute('disabled')) {
        this.addToCart();
      }
    });

    // Event on variants
    if (this.variants.length == 0) return;
    this.variants[0].closest('.section-variants').addEventListener('change', (e) => {
      if (this.variantImageId && e.isTrusted) this.mediaGallery.setActiveMedia(this.variantImageId, false);

      this.setLocalStorageOptions();
      const variantsData = JSON.parse(document.querySelector('#variants_json[type="application/json"]').textContent);
      const currentInput = document.getElementById('current-variant').value;

      let variantTitle = '';

      this.variants.forEach((publicVariant, i) => {
        if (i == this.variants.length - 1) {
          variantTitle += publicVariant.querySelector('input:checked').value;
        } else {
          variantTitle += publicVariant.querySelector('input:checked').value + ' / ';
        }
      });

      let newVariantId;
      variantsData.forEach((variant) => {
        if (variant.title == variantTitle) {
          newVariantId = variant.id;
          if (!newVariantId || newVariantId == currentInput) return;
          this.variants.forEach((publicVariant, i) => {
            publicVariant.previousElementSibling.querySelector('.selected-option-label').innerText = variant.options[i];
          });
          // Update URL
          let searchURLParams = new URLSearchParams(window.location.search);
          searchURLParams.set('variant', newVariantId);
          window.history.replaceState(
            {},
            '',
            window.location.origin + window.location.pathname + `?${searchURLParams}`,
          );
        }
      });

      document.getElementById('current-variant').value = newVariantId;
      document.querySelectorAll('li.voo-dynamic-image').forEach((item) => {
        const image = item.querySelector('img');
        this.updateImageSrc(image, item.dataset.index);
      });

      // if texture updated -> update mat colors
      if (e.target.hasAttribute('name') && e.target.getAttribute('name') == 'Textur') {
        const newOptionValue = e.target.value.toLowerCase();
        document.querySelector('.variant-values[data-texture]').setAttribute('data-texture', newOptionValue);
      }
    });

    // Events to switcher
    document.querySelectorAll('.product-type-switcher').forEach((switcher) => {
      switcher.addEventListener('click', (e) => {
        e.preventDefault();
        const entireURL = e.target.href;
        window.location.href = entireURL;
      });
    });

    document.querySelector('.section-variants').dispatchEvent(new Event('change'));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const searchURLParams = new URLSearchParams(window.location.search);
  const variant = searchURLParams.get('variant');
  // Update option labels
  if (document.querySelector('#variants_json[type="application/json"]') && variant) {
    JSON.parse(document.querySelector('#variants_json[type="application/json"]').textContent).forEach((variant) => {
      if (variant.id == document.getElementById('current-variant').value) {
        document.querySelectorAll('.section-variants .variant-values').forEach((publicVariant, i) => {
          publicVariant.previousElementSibling.querySelector('.selected-option-label').innerText = variant.options[i];

          // if texture updated -> update mat colors
          if (publicVariant.dataset.option && publicVariant.dataset.option == 'Tekstura') {
            const newOptionValue = publicVariant.querySelector('input:checked').value.toLowerCase();
            document.querySelector('.variant-values[data-texture]').setAttribute('data-texture', newOptionValue);
          }
        });
      }
    });
  }
  // Init script
  let productApiData = new ProductAPIData();
  productApiData.init();
});
